export default __webpack_public_path__ + "static/media/Dreamworld.b48af3fa.png";